module.exports = __webpack_public_path__ + "static/media/USDT-PNG.0c23ead2.svg";